import React, { useState, useMemo, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useHistory, useParams } from "react-router-dom";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import PermissionsGate from "../../../utils/permissionGate";
import {
  RenderAssessmentType,
  RenderCourseType,
  RenderTypeInModule,
} from "../../../utils/CommonGroupingItem";
import Swal from "sweetalert2";
import Select from "react-select";
import {
  getProgrameGradeDetails,
  GradeLetterAggregationMethods,
  GradeLetterTemplateDetail,
  GradeLetterTypes,
  updateProgrameGradeDetails,
  getProgrameGradeMixDetails,
  updateProgrammeGradeMixDetails,
  getGradeMixDropdown,
  lockGradeProgrammeGrademixToggle,
  GetStatemantTmpList,
  lockGradeProgrammeToggle,
} from "../../../services/GradeSettingService";
import ListOfTemplateModal from "../CourseGradeSettings/ListOfTemplateModal";
import Str from "../../common/Str";
import { useDispatch } from "react-redux";
import { exportTableData, handleTableScroll, options } from "../../../utils/commonFunction";
import $ from "jquery";
import Tablefilter from "../../common/Tablefilter";
import { GetListOfBrandSettingCancelToken } from "../../../services/BrandServices";
import axios from "axios";
import { setBrandOverride2 } from "../../../store/actions";
import { getPmcVersionGradeSettingDetails, updatePmcVersionGradeSettingDetails } from "../../../services/ProgramService";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useRef } from "react";
import useDebounce from "../../../hooks/useDebounce";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";

/*
  gradingStandard: 1 = normal programme (default), 
  gradingStandard: 2 = GradMix programme.
  versionData will be [] if not PMC Grade setting

  grade types
  0 - percentage
  1 - robot
  2 - letter
  3 - value
  4 - no grade
*/
const ProgrameGradeSetting = ({ gradingStandard = 1, versionData = [] }) => {
  const { id,tab } = useParams();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [assessmentList, setAssessmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gradeLockLoading, setGradeLockLoading] = useState(false);
  const [gradingMethodValue, setGradingMethodValue] = useState("1");
  const [aggregationMethodValue, setAggregationMethodValue] = useState();
  const [gradeTypeValue, setGradeTypeValue] = useState();
  const [dropoutValue, setDropoutValue] = useState("");
  const [passMark, setPassMark] = useState("");
  const [passMarkValue, setPassMarkValue] = useState(null);
  const [formulaValue, setFormulaValue] = useState("");
  const [gradeTypeArr, setGradeTypeArr] = useState([]);
  const [aggregationTypeArr, setAggregationTypeArr] = useState([]);
  const [excludeEmptyGrade, setExcludeEmptyGrade] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [sortOrder, setSortOrder] = useState("ASC");
  const [sortKey, setSortKey] = useState("name");
  const [totalRows, setTotalRows] = useState(0);
  const [isGradeLocked, setIsGradeLocked] = useState(0);
  const [updateData, setUpdateData] = useState(true);
  const [errorMessage, setErrorMessage] = useState({});
  const [editedRows, setEditedRows] = useState([]);
  const weightRefs = useRef({});

  const tooltipObj = {
    aggregationMethodTooltip:
      "Median of grades - If this is selected, the programme grade must be determined by is the middle value (or the mean of the two middle values) when percentages are arranged in order of value for the courses.\nLowest Grade – If this is selected, the programme grade will be the lowest grade achieved for any of its courses.\nHighest Grade - If this is selected, the programme grade will be the highest grade achieved for any of its courses.\nMode of Grades - If this is selected, the programme grade will be the grade that occurs the most frequently.\nNatural - If this is selected, the programme grade will be the sum of all course grades, scaled by their relative weights.",
    dropoutTootltip:
      "The number entered will be used to exclude X number of courses which have the lowest final grade from the final calculation, this will only consider courses which have a weight if natural is selected",
  };
  const [linkedAssessmentDropdown, setLinkedAssessmentDropdown] = useState({
    linkedAssessment: [],
  });
  const [assessmentIds, setAssessmentIds] = useState({ arr: [], checkObj: [] });
  const [brandOverride, setBrandOverride] = useState();
  const [brandList, setBrandList] = useState([]);
  const [sorTemplatevalue, setsorTemplatevalue] = useState();
  const [sorTemplateList, setSorTemplateList] = useState([]);
  const [switchState, setSwitchState] = useState({
    show_assessments: false,
    show_final_results: false,
    show_empty_grades: false,
    allow_student_portal_gradebook_view: false,
    allow_student_portal_sor_to_download: false,
    override_sor_brand: false,
  });
  const dispatch = useDispatch();

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const queryVersionId = query.get("versionId");
  const queryProgrammeId = query.get("programmeId");
  
  // true if - Lock Version Settings toggle is on.
  const isDisabledEdit = versionData?.lock_version_settings || 0;

  useEffect(() => {
    handleTableScroll();
  }, [loading]);

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $(".rdt_TableCell").css("z-index", 0);
        $(this).parents(".rdt_TableCell").css("z-index", 22);
      });
    });
  });

  usePermissionGuardRedirect(['capgseview']);

  let templatePassMarkArr = [];
  let templateArray =
    selectedTemplate?.gradeOptions?.length &&
    selectedTemplate?.gradeOptions.map((item) => {
      templatePassMarkArr.push({
        value: item?.id,
        label: item?.text,
      });
    });

  useEffect(() => {
    const dropdownSource = axios.CancelToken.source();

    const fetchData = async () => {
      try {
        const response = await GetListOfBrandSettingCancelToken(dropdownSource.token);
        if (response?.status == 200) {
          const brands = response.data.brand_setting_list.map(brand => ({
            label: brand.brand_name,
            value: brand.id
          }))
          const sortedBrands = brands.sort((a, b) => {
            if (a.label?.toLowerCase() < b.label?.toLowerCase()) {
              return -1
            } else if (a.label?.toLowerCase() > b.label?.toLowerCase()) {
              return 1
            }
            return 0
          })
          setBrandList(sortedBrands)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    fetchData();

    return () => {
      dropdownSource.cancel('Component unmounted');
    };
  }, []);

  useEffect(() => {
    const cancelTokenSources = [];

    const getData = async () => {
      setLoading(true);

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      const data = {
        page: 1,
        limit: 10,
        search: '',
        key: 'name',
        sort: 'asc',
        exportStatus: "true",
        viaKeywords: [],
        viaTopics: [],
      };

      try {
        const res = await GetStatemantTmpList(data, source.token);
        if (res.status === 200) {
          const sorTemplates = res.data?.result.map(template => ({
            label: template.name,
            value: template.id
          }))
          setLoading(false)
          const sortedTemplates = sorTemplates.sort((a, b) => {
            if (a.label.toLowerCase() > b.label.toLowerCase()) {
              return -1
            } else if (a.label.toLowerCase() > b.label.toLowerCase()) {
              return 1
            }
            return 0
          })
          setSorTemplateList(sortedTemplates);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }

    getData();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    }
  }, []);
  
  useEffect(() => {
    setLoading(true);
    let data = {
      id,
      page: 1,
      limit: 10,
      key: sortKey,
      sort: sortOrder,
      exportStatus: "true",
      search: debouncedSearch,
    };
    if (gradingStandard) {
      if (gradingStandard == 2) {
        data.viaAssessment = assessmentIds.arr;
        getProgrameGradeMixDetails(data)
          .then((res) => {
            let details = res.data?.details;
            let assessment_data = res?.data?.gradeMixList;
            setsorTemplatevalue(details?.st_template)
            setBrandOverride(details?.override_brand)

            setSwitchState({
              show_assessments: details.show_assessments,
              show_final_results: details.show_final_results,
              show_empty_grades: details.show_empty_grades,
              allow_student_portal_gradebook_view: details.allow_student_portal_gradebook_view,
              allow_student_portal_sor_to_download: details.allow_student_portal_sor_to_download,
              override_sor_brand: details.override_sor_brand
            })
            setAssessmentList(assessment_data ? assessment_data : []);
            setAggregationMethodValue(details?.aggregation_method_id);
            setExcludeEmptyGrade(details?.exclude_empty_grades);
            setGradeTypeValue(details?.grading_type);
            setFormulaValue(details?.formula);
            if (details?.grading_type == "1" || details?.grading_type == "2") {
              setPassMarkValue(details?.pass_mark);
            } else {
              setPassMark(details?.pass_mark);
            }
            setDropoutValue(
              details?.drop_lowest_amount == 0
                ? ""
                : details?.drop_lowest_amount
            );
            setTotalRows(res.data?.gradeMixList?.length);
            setIsGradeLocked(details?.lock_grades);
            if (details?.grading_type == "2") {
              GradeLetterTemplateDetail({ id: details?.grading_template_id })
                .then((res) => {
                  setSelectedTemplate(res?.data?.list_data[0]);
                  setEditedRows([]);
                  setLoading(false);
                })
                .catch((err) => {
                  setLoading(false);
                  console.error(err);
                });
            }
            setLoading(false);
          })
          .catch((err) => {
            console.error("error :", err);
            setLoading(false);
          });
      } else {
        const fetchGradeDetails = () => {
          if (queryVersionId) {
            return getPmcVersionGradeSettingDetails({ ...data, versionId: queryVersionId });
          }
          return getProgrameGradeDetails({ ...data, id });
        };
        
        fetchGradeDetails()
          .then((res) => {
            dispatch(setBrandOverride2(res.data?.data.override_brand))
            let details = res.data?.data;
            let assessment_data = res?.data?.[queryVersionId ? 'modules' : 'courseAndAssessment'];
            setsorTemplatevalue(details?.st_template)
            setBrandOverride(details?.override_brand)
            setSwitchState({
              show_assessments: details.show_assessments,
              show_final_results: details.show_final_results,
              show_empty_grades: details.show_empty_grades,
              allow_student_portal_gradebook_view: details.allow_student_portal_gradebook_view,
              allow_student_portal_sor_to_download: details.allow_student_portal_sor_to_download,
              override_sor_brand: details.override_sor_brand
            })
            setAssessmentList(assessment_data ? assessment_data : []);
            setAggregationMethodValue(details?.aggregation_method_id);
            setExcludeEmptyGrade(details?.exclude_empty_grades);
            setGradeTypeValue(details?.grading_type);
            setFormulaValue(details?.formula);
            if (details?.grading_type == "1" || details?.grading_type == "2") {
              setPassMarkValue(details?.pass_mark);
            } else {
              setPassMark(details?.pass_mark);
            }
            setDropoutValue(
              details?.drop_lowest_amount == 0
                ? ""
                : details?.drop_lowest_amount
            );
            setTotalRows(res.data?.courseAndAssessment?.length);
            setIsGradeLocked(res.data?.data?.lock_grades);
            if (details?.grading_type == "2") {
              GradeLetterTemplateDetail({ id: details?.grading_template_id })
                .then((res) => {
                  setSelectedTemplate(res?.data?.list_data[0]);
                  setEditedRows([]);
                  setLoading(false);
                })
                .catch((err) => {
                  setLoading(false);
                  console.error(err);
                });
            }
            setLoading(false);
          })
          .catch((err) => {
            console.error("error :", err);
            setLoading(false);
          });
      }
    }
  }, [
    id,
    updateData,
    gradingStandard,
    assessmentIds,
  ]);

  useEffect(() => {
    if (gradingStandard && gradingStandard == 2) {
      let data = {
        gradeMixIds: id,
        type: "programme",
      };
      getGradeMixDropdown(data)
        .then((res) => {
          setLinkedAssessmentDropdown({
            ...res.data,
            linkedAssessment: res?.data?.assessment
              ? res?.data?.assessment
              : [],
          });
        })
        .catch((err) => console.error(err));
    }
  }, [gradingStandard]);

  useEffect(() => {
    GradeLetterTypes()
      .then((res) => {
        setGradeTypeArr(res?.data);
      })
      .catch((err) => console.error(err));
    GradeLetterAggregationMethods()
      .then((res) => {
        setAggregationTypeArr(res?.data);
      })
      .catch((err) => console.error(err));
  }, []);

  const handleWeightChange = (e, assId) => {
    const cursorPos = e.target.selectionStart;
    let rawValue = e.target.value;

    // Only allow digits
    if (!/^\d*$/.test(rawValue)) return;

    const value = rawValue === "" ? 0 : Number(rawValue);
    const isVersion = !!queryVersionId;

    // Helper: get field name based on gradingStandard / version
    const field = isVersion || gradingStandard === 2 ? "weight" : "ass_weighting";

    // ----------------------------
    // 1. Update assessmentList
    // ----------------------------
    const updatedAssessmentList = assessmentList.map(item =>
      (isVersion ? item.MId === assId : item.id === assId)
        ? { ...item, [field]: value }
        : item
    );
    setAssessmentList(updatedAssessmentList);

    // ----------------------------
    // 2. Update editedRows
    // ----------------------------
    setEditedRows(prev => {
      const idx = prev.findIndex(item => isVersion ? item.MId === assId : item.id === assId);
      const original = updatedAssessmentList.find(item => isVersion ? item.MId === assId : item.id === assId);
      const newItem = { ...original };

      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = newItem;
        return copy;
      }
      return [...prev, newItem];
    });

    // ----------------------------
    // 3. Validate weight > 100
    // ----------------------------
    const hasInvalid = updatedAssessmentList.some(item => Number(item[field]) > 100);
    setErrorMessage(prev => {
      if (hasInvalid) return { ...prev, queryVersionId: "Weight cannot be greater than 100" };
      const copy = { ...prev };
      delete copy.queryVersionId;
      return copy;
    });

    // ----------------------------
    // 4. Restore focus & cursor
    // ----------------------------
    setTimeout(() => {
      const input = weightRefs.current[assId];
      if (input) {
        input.focus();
        input.setSelectionRange(cursorPos, cursorPos);
      }
    }, 0);
  };

  const handlePassRequiredChange = (checked, assId, key = "") => {
    const isVersion = !!queryVersionId;

    const filteredObj = assessmentList.find((item) =>
      isVersion ? item.MId === assId : item.id === assId
    );

    if (!filteredObj) return;

    const updatedObj = {
      ...filteredObj,
      [key]: checked ? 1 : 0
    };

    // ------ update assessmentList ------
    setAssessmentList(prev => {
      const key = isVersion ? "MId" : "id";
      return prev.map(item =>
        item[key] === assId ? updatedObj : item
      );
    });


    // ------ update editedRows ------
    setEditedRows(prev => {
      const key = isVersion ? "MId" : "id";
      return [
        ...prev.filter(item => item[key] !== assId),
        updatedObj
      ];
    });

  };

  const dataToRender = () => {
    let updatedData = [];
    let allData = assessmentList;

    // Search filter - based on name only
    if (debouncedSearch.length) {
      updatedData = allData.filter((item) => {
        const searchLower = search.toLowerCase();

        // For version/module data
        if (queryVersionId) {
          return (
            item.Portal &&
            item.Portal.toLowerCase().includes(searchLower)
          );
        }

        // For grade mix
        if (gradingStandard === 2) {
          const hasAssessmentMatch = item.getAssessmentlist?.some(
            assessment => assessment.name &&
              assessment.name.toLowerCase().includes(searchLower)
          );

          return (
            (item.name && item.name.toLowerCase().includes(searchLower)) ||
            hasAssessmentMatch
          );
        }

        // For regular programme data - search by name only
        return (
          item.name &&
          item.name.toLowerCase().includes(searchLower)
        );
      });
    } else {
      updatedData = allData;
    }

    // Filter by linked assessments (only for grade mix)
    if (gradingStandard === 2 && assessmentIds.arr.length > 0) {
      updatedData = updatedData.filter((item) => {
        return item.getAssessmentlist?.some((assessment) =>
          assessmentIds.arr.includes(assessment.assignment_id?.toString())
        );
      });
    }

    // Client-side sorting
    if (sortKey && updatedData.length > 0) {
      updatedData.sort((a, b) => {
        let aValue, bValue;

        // Handle ID sorting for different data types
        if (sortKey === 'id') {
          if (queryVersionId) {
            // For module/version data, use MId
            aValue = Number(a.MId) || 0;
            bValue = Number(b.MId) || 0;
          } else {
            // For regular/grade mix data, use id
            aValue = Number(a.id) || 0;
            bValue = Number(b.id) || 0;
          }
        }
        // Handle name sorting
        else if (sortKey === 'name') {
          if (queryVersionId) {
            aValue = a.Portal || '';
            bValue = b.Portal || '';
          } else {
            aValue = a.name || '';
            bValue = b.name || '';
          }
        }
        // Handle other fields
        else {
          aValue = a[sortKey];
          bValue = b[sortKey];
        }

        // Handle null/undefined values
        if (aValue === null || aValue === undefined) aValue = '';
        if (bValue === null || bValue === undefined) bValue = '';

        // Numeric sorting
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return sortOrder === 'ASC' || sortOrder === 'AESC'
            ? aValue - bValue
            : bValue - aValue;
        }

        // String sorting
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();

        if (sortOrder === 'ASC' || sortOrder === 'AESC') {
          return aStr.localeCompare(bStr, undefined, { numeric: true });
        } else {
          return bStr.localeCompare(aStr, undefined, { numeric: true });
        }
      });
    }

    return updatedData;
  };

  const columns = useMemo(() => [
    {
      name: "Item",
      selector: "name",
      sortField: "name",
      sortable: true,
      cell: (row) => {
        return (
          <span
            title={row?.name ? row.name : "-"}
            className="overflow-ellipsis2 "
          >
            {row.name ? (
              <Link
                className="as-text-blue curser feature-name"
                to={
                  row?.isAssessment == 0
                    ? `/courseAdministration/coursesdetails/${row?.id}/gradeSettings/show`
                    : `/courseAdministration/coursesdetails/${row.intakeID}/assessments/open/assigned/Details/${row.id}`
                }
              >
                <span className="textLimit100">
                  {row?.name ? row.name : "-"}
                </span>
              </Link>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
    {
      name: "ID",
      selector: "id",
      sortField: "id",
      sortable: true,
      cell: (row) => <p>{row.id ? row.id : "-"}</p>,
    },
    gradingMethodValue == 1 &&
      aggregationMethodValue == 6 && {
        name: "Weight",
        selector: "ass_weighting",
        sortable: false,
        cell: (row) => (
          <div
            className="input_wt02 resultstatus_flex arrowhide"
            title="Weight"
          >
            <PermissionsGate
              scopes={["capgseedit"]}
              errorProps={{ disabled: true }}
            >
              <input
                className={`
                  form-control custom-select-box
                  ${row?.ass_weighting > 100 ? "is-invalid" : ""}
                  ${isDisabledEdit || isGradeLocked ? "block-action" : ""}
                `}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                ref={(el) => (weightRefs.current[row.id] = el)}
                value={row?.ass_weighting !== undefined && row?.ass_weighting !== null ? row?.ass_weighting : ""} // Set the initial value from the data
                onChange={(e) => handleWeightChange(e, row.id)}
                disabled={isDisabledEdit || isGradeLocked}
              />
            </PermissionsGate>
          </div>
        ),
      },
    {
      name: "Maximum Grade",
      selector: "maximumGrade",
      sortable: false,
      sortField: "maximumGrade",
      cell: (row) => (row?.maximumGrade ? row?.maximumGrade : "-"),
    },
    {
      name: "Pass Required",
      selector: "pass_required",
      sortable: false,
      cell: (row) => (
        <div
          className="custom-control custom-checkbox text-left table-curser"
          title="Pass Required"
        >
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className={`custom-control-input ${isDisabledEdit ? "block-action" : isGradeLocked ? "block-action" : ""}`}
              id={`pass_required${row.id}`}
              name="pass_required"
              checked={row.pass_required} // Set the initial value from the data
              onChange={(e) => {
                handlePassRequiredChange(
                  e.target?.checked,
                  row.id,
                  "pass_required"
                );
              }} // Define a function to handle value changes
              disabled={isDisabledEdit || isGradeLocked}
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row.id}></label>
        </div>
      ),
    },
    aggregationMethodValue != 6 && {
      name: "Exclude from calculation",
      selector: "exclude_from_calculation",
      sortable: false,
      cell: (row) => (
        <div
          className="custom-control custom-checkbox text-left table-curser"
          title="Pass Required"
        >
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className={"custom-control-input"+(isDisabledEdit ? " block-action" :  isGradeLocked ? " block-action" : "")}
              id={`exclude_from_calculation${row.id}`} // change id
              name="exclude_from_calculation"
              defaultChecked={row.exclude_from_calculation} // Set the initial value from the data
              onChange={(e) => {
                handlePassRequiredChange(
                  e.target?.checked,
                  row.id,
                  "exclude_from_calculation"
                );
              }} // Define a function to handle value changes
              disabled={isDisabledEdit || isGradeLocked}
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row.id}></label>
        </div>
      ),
    },
    {
      name: "Course Type",
      selector: "assessment_type",
      sortField: "assessment_type",
      sortable: false,
      cell: (row) =>
        (row?.assessment_type || row?.subject_type)
          ? row.isAssessment
            ? RenderAssessmentType(row?.assessment_type).html
            : RenderCourseType(row?.subject_type).html
          : "-",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <PermissionsGate
              scopes={["cagsview"]}
              RenderError={() => (
                <button className="btn btn-primary rounded-circle" title="Open">
                  <i className="fal fa-folder-open"></i>
                </button>
              )}
            >
              <Link
                className="mr-1"
                to={`/courseAdministration/coursesdetails/${row?.id}/gradeSettings/show`}
              >
                <button className="btn btn-primary rounded-circle" title="Open">
                  <i className="fal fa-folder-open"></i>
                </button>
              </Link>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const moduleColumns = useMemo(() => [
    {
      name: "Item",
      selector: "name",
      sortField: "name",
      sortable: true,
      cell: (row) => {
        return (
          <span
            title={row?.Portal ? row.Portal : "-"}
            className="overflow-ellipsis2 "
          >
            {row?.Portal ? (
              <Link
                className="as-text-blue curser feature-name"
                to={`/program-management-center/modules/module/open/${row.MId}`}
              >
                <span className="textLimit100">
                  {row?.Portal}
                </span>
              </Link>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
    {
      name: "ID",
      selector: "MId",
      sortField: "MId",
      sortable: true,
      cell: (row) => <p>{row?.MId ?? "-"}</p>,
    },
    ...(gradingMethodValue == 1 && aggregationMethodValue == 6
      ? [{
      name: "Weight",
      selector: "weight",
      sortable: false,
      cell: (row) => (
        <div
          className="input_wt02 resultstatus_flex arrowhide"
          title="Weight"
        >
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              ref={(el) => (weightRefs.current[row.MId] = el)}
              className={
                "form-control custom-select-box" +
                (row?.weight > 100 ? " is-invalid" : "") +
                (isDisabledEdit ? " block-action" : isGradeLocked ? " block-action" : "")
              }
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={row?.weight ?? ""}
              onChange={(e) => handleWeightChange(e, row.MId)}
              disabled={isDisabledEdit || isGradeLocked}
            />
          </PermissionsGate>
        </div>
      ),
      }]
      : []),
    {
      name: "Pass Required",
      selector: "pass_required",
      sortable: false,
      cell: (row) => (
        <div
          className="custom-control custom-checkbox text-left table-curser"
          title="Pass Required"
        >
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className={`custom-control-input ${isDisabledEdit ? "block-action" : isGradeLocked ? "block-action" : ""}`}
              id={`pass_required${row.MId}`}
              name="pass_required"
              checked={row.pass_required} // Set the initial value from the data
              onChange={(e) => {
                handlePassRequiredChange(
                  e.target?.checked,
                  row.MId,
                  "pass_required"
                );
              }} // Define a function to handle value changes
              disabled={isDisabledEdit || isGradeLocked}
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row?.MId}></label>
        </div>
      ),
    },
    ...(aggregationMethodValue != 6 ? [{
      name: "Exclude from calculation",
      selector: "exclude_from_calculation",
      sortable: false,
      cell: (row) => (
        <div
          className="custom-control custom-checkbox text-left table-curser"
          title="Pass Required"
        >
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className={"custom-control-input" + (isDisabledEdit ? " block-action" : isGradeLocked ? " block-action" : "")}
              id={`exclude_from_calculation${row.MId}`} // change id
              name="exclude_from_calculation"
              defaultChecked={row.exclude_from_calculation} // Set the initial value from the data
              onChange={(e) => {
                handlePassRequiredChange(
                  e.target?.checked,
                  row.MId,
                  "exclude_from_calculation"
                );
              }} // Define a function to handle value changes
              disabled={isDisabledEdit || isGradeLocked}
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row.MId}></label>
        </div>
      )
    }] : []),
    {
      name: "Module Type",
      selector: "assessment_type",
      sortField: "assessment_type",
      sortable: false,
      cell: (row) => (
        <div className="d-inline-block module-type">
          {row?.type ? RenderTypeInModule(row?.type).html : "-"}
        </div>
      )
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <PermissionsGate
              scopes={["cagsview"]}
              RenderError={() => (
                <button className="btn btn-primary rounded-circle" title="Open">
                  <i className="fal fa-folder-open"></i>
                </button>
              )}
            >
              <Link
                className="mr-1"
                to={`/program-management-center/modules/module/open/${row.MId}`}
              >
                <button className="btn btn-primary rounded-circle" title="Open">
                  <i className="fal fa-folder-open"></i>
                </button>
              </Link>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const LinkedAssessmentCell = ({ row }) => {
    const [showAll, setShowAll] = useState(false);
    const maxItemsToShow = 2;

    const linkedAssessment = row?.getAssessmentlist || [];
    const visibleIds = showAll
      ? linkedAssessment
      : linkedAssessment.slice(0, maxItemsToShow);

    const toggleShowAll = () => {
      setShowAll(!showAll);
    };

    return (
      <div>
        {visibleIds.map((item, index) => (
          <div key={index}>
            <span
              title={item?.name ? item?.name : ""}
              className="overflow-ellipsis2 "
            >
              {item?.name ? (
                <Link
                  className="as-text-blue curser feature-name font-weight-bold"
                  to={`/courseAdministration/coursesdetails/${item.intake}/assessments/open/assigned/Details/${item.assignment_id}`}
                >
                  <span className="textLimit100">{item?.name}</span>
                </Link>
              ) : (
                "-"
              )}
            </span>
          </div>
        ))}
        {linkedAssessment.length > maxItemsToShow && (
          <span
            className="see-more cursor-pointer as-text-blue"
            onClick={toggleShowAll}
          >
            {showAll ? "See Less" : "...See More"}
          </span>
        )}
      </div>
    );
  };

  const gradeMixColumns = useMemo(() => [
    {
      name: "Item",
      selector: "name",
      sortField: "name",
      sortable: true,
      cell: (row) => {
        return (
          <span
            title={row?.name ? row.name : "-"}
            className="overflow-ellipsis2 "
          >
            {row.name ? (
              <Link
                className="as-text-blue curser feature-name"
                to={`/courseAdministration/gradeMix/${id}/details/${row?.id}/open`}
              >
                <span className="textLimit100">{row.name}</span>
              </Link>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
    {
      name: "Linked Assessment",
      selector: "id",
      sortField: "id",
      cell: (row) => <LinkedAssessmentCell row={row} />,
    },
    gradingMethodValue == 1 &&
      aggregationMethodValue == 6 && {
        name: "Weight",
        selector: "ass_weighting",
        sortable: false,
        cell: (row) => (
          <div
            className="input_wt02 resultstatus_flex arrowhide"
            title="Weight"
          >
            <PermissionsGate
              scopes={["capgseedit"]}
              errorProps={{ disabled: true }}
            >
              <input
                className={
                  "form-control custom-select-box" +
                  ((row.weight > 100) ? " is-invalid" : "")+(isDisabledEdit ? " block-action" :  isGradeLocked ? " block-action" : "")
                }
                ref={(el) => (weightRefs.current[row.id] = el)}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={row.weight !==undefined && row?.weight !== null ? row?.weight : ""} // Set the initial value from the data
                onChange={(e) => handleWeightChange(e, row.id)}
                disabled={isDisabledEdit || isGradeLocked}
              />
            </PermissionsGate>
          </div>
        ),
      },
    {
      name: "Maximum Grade",
      selector: "maximumGrade",
      sortable: false,
      sortField: "maximumGrade",
      cell: (row) => (row?.maximumGrade ? row?.maximumGrade : "-"),
    },
    {
      name: "Pass Required",
      selector: "pass_required",
      sortable: false,
      cell: (row) => (
        <div
          className="custom-control custom-checkbox text-left table-curser"
          title="Pass Required"
        >
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className={"custom-control-input"+(isDisabledEdit ? " block-action" :  isGradeLocked ? " block-action" : "")}
              id={`pass_required${row.id}`}
              name="pass_required"
              checked={row.pass_required} // Set the initial value from the data
              onChange={(e) => {
                handlePassRequiredChange(
                  e.target?.checked,
                  row.id,
                  "pass_required"
                );
              }} // Define a function to handle value changes
              disabled={isDisabledEdit || isGradeLocked}
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row.id}></label>
        </div>
      ),
    },
    aggregationMethodValue != 6 && {
      name: "Exclude from calculation",
      selector: "exclude_from_calculation",
      sortable: false,
      cell: (row) => (
        <div
          className="custom-control custom-checkbox text-left table-curser"
          title="Pass Required"
        >
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <input
              type="checkbox"
              className={"custom-control-input"+(isDisabledEdit ? " block-action" :  isGradeLocked ? " block-action" : "")}
              id={`exclude_from_calculation${row.id}`} // change id
              name="exclude_from_calculation"
              defaultChecked={row.exclude_from_calculation} // Set the initial value from the data
              onChange={(e) => {
                handlePassRequiredChange(
                  e.target?.checked,
                  row.id,
                  "exclude_from_calculation"
                );
              }} // Define a function to handle value changes
              disabled={isDisabledEdit || isGradeLocked}
            />
          </PermissionsGate>
          <label className="custom-control-label" htmlFor={row.id}></label>
        </div>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <PermissionsGate
              scopes={["cagsview"]}
              RenderError={() => (
                <button className="btn btn-primary rounded-circle" title="Open">
                  <i className="fal fa-folder-open"></i>
                </button>
              )}
            >
              <Link
                className="mr-1"
                to={`/courseAdministration/gradeMix/${id}/details/${row?.id}/open`}
              >
                <button className="btn btn-primary rounded-circle" title="Open">
                  <i className="fal fa-folder-open"></i>
                </button>
              </Link>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const exportData = async (fileType, fileName) => {
    try {
      Swal.fire({
        title: "File Downloading...",
        onOpen: () => {
          Swal.showLoading();
        }
      });

      let rawData = dataToRender() || [];

      let headers = [
        "Item",
        "ID",
        "Type",
        "Weight",
        "Maximum Grade",
        "Pass Required",
        "Exclude from calculation",
        "Course Type",
        "Module Type"
      ];

      if (queryVersionId) {
        headers = headers.filter(h => !["Maximum Grade", "Course Type", "Type"].includes(h));
      } else {
        headers = headers.filter(h => !["Module Type", "Exclude from calculation"].includes(h));
      }

      if (!(gradingMethodValue == 1 && aggregationMethodValue == 6)) {
        headers = headers.filter(h => h !== "Weight");
      }

      const rows = rawData.map(row => {

        const base = {
          Item: (queryVersionId ? row?.Portal : row?.name) ?? "-",
          ID: (queryVersionId ? row?.MId : row?.id) ?? "-",
          Type:
            row?.isAssessment == null
              ? "-"
              : row.isAssessment == 0
                ? "Course"
                : "Assessment",

          // GOOD
          Weight:
            (queryVersionId
              ? row?.weight
              : row?.ass_weighting) != null
              ? (queryVersionId ? row?.weight : row?.ass_weighting)
              : "-",

          "Maximum Grade": row?.maximumGrade != null ? row.maximumGrade : "-",

          "Pass Required":
            row?.pass_required != null
              ? (row.pass_required ? "True" : "False")
              : "-",

          "Exclude from calculation":
            row?.exclude_from_calculation != null
              ? (row.exclude_from_calculation ? "True" : "False")
              : "-",

          "Course Type": row?.assessment_type
            ? row.isAssessment
              ? RenderAssessmentType(row.assessment_type)?.text ?? "-"
              : RenderCourseType(row.assessment_type)?.text ?? "-"
            : "-",

          "Module Type": RenderTypeInModule(row?.type).text ?? "-"
        };

        const filtered = {};
        headers.forEach(h => filtered[h] = base[h] ?? "-");

        return filtered;
      });

      await exportTableData(fileType, fileName, headers, rows);
      Swal.close()
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error"
      });
    }
  };


  const exportGradeMixData = (fileType, fileName) => {
    let data = {
      id,
      page: 1,
      limit: 10,
      key: sortKey,
      sort: sortOrder,
      exportStatus: "true",
      search: debouncedSearch,
      viaAssessment: assessmentIds.arr,
    };
    getProgrameGradeMixDetails(data)
      .then((res) => {
        let assessment_data = res?.data?.gradeMixList || [];
        const header = [
          "Item",
          "Linked Assessments",
          "Weight",
          "Maximum Grade",
          "Pass Required",
        ];
        const data = [];
        assessment_data.map((gradeMix, index) => {
          let details = {
            Item: gradeMix?.name ? gradeMix.name : "-",
            "Linked Assessments": "",
            Weight: gradeMix?.weight !==undefined && gradeMix?.weight !== null ? gradeMix?.weight : "-",
            "Maximum Grade": gradeMix?.maximumGrade
              ? gradeMix?.maximumGrade
              : "-",
            "Pass Required": gradeMix.pass_required == "0" ? "False" : "True",
          };
          data.push(details);
          gradeMix.getAssessmentlist.map((item, index) => {
            let assessmentsNames = {
              Item: "",
              "Linked Assessments": item?.name ? item?.name : "-",
              Weight: "",
              "Maximum Grade": "",
              "Pass Required": "",
            };
            data.push(assessmentsNames);
          });
        });
        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, data });
          const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
          });

          const blobURL = window.URL.createObjectURL(blob);

          // Create new tag for download file
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();

          // Remove URL.createObjectURL. The browser should not save the reference to the file.
          setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
          }, 1000);
        } else if (fileType === "xlsx") {
          const compatibleData = data.map((row) => {
            const obj = {};
            header.map((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);

          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = data.map((row) => {
            return [
              row["Item"],
              row["Linked Assessments"],
              row["Weight"],
              row["Maximum Grade"],
              row["Pass Required"],
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);

          return false;
        }
      })
      .catch((error) => {
        console.error("error :", error);
      });
  };

  const resetFilter = () => {
    setSearch("");
    setAssessmentIds({ arr: [], checkObj: [] });
  };

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleUpdateData = () => {
    let tempErrorMessage = errorMessage;

    if (gradeTypeValue === undefined || gradeTypeValue == "5") {
      tempErrorMessage = {
        ...tempErrorMessage,
        gradeType: "Grade Type is Required",
      };
    } else {
      delete tempErrorMessage?.gradeType;
    }
    if (
      aggregationMethodValue === undefined &&
      gradeTypeValue !== undefined &&
      gradeTypeValue != 3
    ) {
      tempErrorMessage = {
        ...tempErrorMessage,
        aggregationMethod: "Aggregation Method is Required",
      };
    } else {
      delete tempErrorMessage?.aggregationMethod;
    }
    if (gradeTypeValue == "2" || gradeTypeValue == "1") {
      if (passMarkValue === null || passMarkValue === "") {
        tempErrorMessage = {
          ...tempErrorMessage,
          passMark: "Pass Mark is Required",
        };
      } else {
        delete tempErrorMessage?.passMark;
      }
    } else if (gradeTypeValue == "0") {
      if (passMark == "") {
        tempErrorMessage = { ...tempErrorMessage, passMark: "Pass Mark is Required" }
      } else if (passMark > 100) {
        tempErrorMessage = { ...tempErrorMessage, passMark: "Pass Mark cannot be more than 100%" }
      } else {
        delete tempErrorMessage?.passMark
      }
    } else {
      if (passMark == "" && (gradeTypeValue == "0" || gradeTypeValue == "3")) {
        tempErrorMessage = {
          ...tempErrorMessage,
          passMark: "Pass Mark is Required",
        };
      } else {
        delete tempErrorMessage?.passMark;
      }
    }
    if (
      gradingStandard != 2 &&
      dropoutValue > totalRows - 1 &&
      gradeTypeValue != 3
    ) {
      tempErrorMessage = {
        ...tempErrorMessage,
        dropoutValue: "Dropout Value Must Be Smaller Than Total Assessments",
      };
    } else {
      delete tempErrorMessage?.dropoutValue;
    }
    if (
      gradingStandard == 2 &&
      dropoutValue > totalRows - 1 &&
      gradeTypeValue != 3
    ) {
      tempErrorMessage = {
        ...tempErrorMessage,
        dropoutValue:
          "Dropout Value Must Be Smaller Than Total Grade Mix Items",
      };
    } else {
      delete tempErrorMessage?.dropoutValue;
    }
    if (!selectedTemplate?.id && gradeTypeValue == "2") {
      tempErrorMessage = {
        ...tempErrorMessage,
        template: "Template is Required",
      };
    } else {
      delete tempErrorMessage?.template;
    }
    setErrorMessage(tempErrorMessage);
    if (Object.keys(tempErrorMessage).length) {
      return;
    }
    setIsDisabled(true);
    let data = {
      ...switchState,
      drop_lowest_amount: dropoutValue ? dropoutValue : 0,
      exclude_empty_grades: excludeEmptyGrade,
      formula: formulaValue,
      grading_method_id: 1,
      id,
      grading_template_id: selectedTemplate?.id ? selectedTemplate?.id : 0,
      grading_type: gradeTypeValue,
      pass_mark:
        gradeTypeValue == "1" || (gradeTypeValue == "2" && passMarkValue)
          ? passMarkValue
          : passMark
          ? passMark
          : 0,
    };
    if (brandOverride) {
      data.override_brand = brandOverride
    }else{
      data.override_brand = 0
    }
    if (sorTemplatevalue) {
      data.st_template = sorTemplatevalue
    }else{
      data.st_template = 0
    }
    if (gradingMethodValue == "1") {
      data.aggregation_method_id =
        gradeTypeValue != 3 ? aggregationMethodValue : 1;
    }
    if (gradingStandard == 2) {
      data.gradeMix = JSON.stringify(editedRows);
      updateProgrammeGradeMixDetails(data)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Updated Successfully",
          });
          setIsDisabled(false);
          setUpdateData(!updateData);
          setEditedRows([]);
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something Went Wrong",
          });
          setIsDisabled(false);
          setUpdateData(!updateData);
          console.error("err: ", err);
        });
    } else {
      //queryVersionId will is PMC grade setting
      if (queryVersionId) {
        const sharedData = editedRows.map(row => ({
          version_id: queryVersionId,
          MId:row?.MId,
          PId: queryProgrammeId,
          pass_required: row.pass_required,
          exclude_from_calculation: row.exclude_from_calculation,
          weight: row.weight
        }));

        data.modules = JSON.stringify(sharedData);    
      } else {
        data.assessment = JSON.stringify(editedRows);     
      }
      
      function dataUpdated() {
        if (queryVersionId) {
          return updatePmcVersionGradeSettingDetails({ ...data, versionId: queryVersionId });
        }
        return updateProgrameGradeDetails({ ...data, id });
      }
      dataUpdated()
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Updated Successfully",
          });
          setIsDisabled(false);
          setUpdateData(!updateData);
          setEditedRows([]);
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something Went Wrong",
          });
          setIsDisabled(false);
          setUpdateData(!updateData);
          console.error("err: ", err);
        });
    }
  };

  const handleSort = (column, sortDirection) => {
    setSortKey(column.sortField);
    setSortOrder(sortDirection === "asc" ? "AESC" : "DESC");
  };

  const handleSwitchToggle = (switchName) => {
    setSwitchState((prevState) => ({
      ...prevState,
      [switchName]: !prevState[switchName],
    }));
  };

  const handleLockGrades = () => {
    setGradeLockLoading(true)
    if (gradingStandard == 2) {
      lockGradeProgrammeGrademixToggle(id, isGradeLocked ? 0 : 1)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.message,
          });
          setUpdateData(!updateData);
          setGradeLockLoading(false)
        })
        .catch((err) => {
          console.error("error :", err);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: err.response.data.message,
          });
          setGradeLockLoading(false)
        });
    } else {
      lockGradeProgrammeToggle(id ,isGradeLocked ? 0 : 1)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message,
        });
        setUpdateData(!updateData);
        setGradeLockLoading(false)
      })
      .catch((err) => {
        console.error("error :", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.message,
        });
        setGradeLockLoading(false)
      });
    }
  }

  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
      <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
        <div className="grade-setting-box">
          <div className="course-info-sec">
            <div className="edit-icon new-card-header">
              <div className="card-header">
                Grade Settings{" "}
                {loading ? <i className="fas fa-cog fa-spin"></i> : ""}
              </div>
            </div>
            
            <div className="card-body-inr card-body-info">
              <div className="edit-icon new-card-header">
                <div className="card-header">
                <i className="fas fa-cog heading-theme-color mr-2"></i> 
                  Statement of Results{" "}
                  {loading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Show Assessments">
                    <label className="mb-0">
                      Show Assessments{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.show_assessments}
                          onChange={() => handleSwitchToggle("show_assessments")}
                          disabled={isDisabledEdit}
                        />
                        <span className={`slider slider-round ${isDisabledEdit ? "block-action" : ""}`}></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Show Final Results">
                    <label className="mb-0">
                      Show Final Results{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.show_final_results}
                          onChange={() =>
                            handleSwitchToggle("show_final_results")
                          }
                          disabled={isDisabledEdit}
                        />
                        <span className={`slider slider-round ${isDisabledEdit ? "block-action" : ""}`}></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Show Empty Grades">
                    <label className="mb-0">
                      Show Empty Grades{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.show_empty_grades}
                          onChange={() => handleSwitchToggle("show_empty_grades")}
                          disabled={isDisabledEdit}
                        />
                        <span className={`slider slider-round ${isDisabledEdit ? "block-action" : ""}`}></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Allow Student Portal Gradebook View">
                    <label className="mb-0">
                      Allow Student Portal Gradebook View{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.allow_student_portal_gradebook_view}
                          onChange={() =>
                            handleSwitchToggle("allow_student_portal_gradebook_view")
                          }
                          disabled={isDisabledEdit}
                        />
                        <span className={`slider slider-round ${isDisabledEdit ? "block-action" : ""}`}></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Allow Student Portal SOR Download">
                    <label className="mb-0">
                      Allow Student Portal SOR Download{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.allow_student_portal_sor_to_download}
                          onChange={() =>
                            handleSwitchToggle("allow_student_portal_sor_to_download")
                          }
                          disabled={isDisabledEdit}
                        />
                        <span className={`slider slider-round ${isDisabledEdit ? "block-action" : ""}`}></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-2">
                  <div className="d-flex align-items" title="Override SOR Brand">
                    <label className="mb-0">
                      Override SOR Brand{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={switchState.override_sor_brand}
                          onChange={() =>
                            handleSwitchToggle("override_sor_brand")
                          }
                          disabled={isDisabledEdit}
                        />
                        <span className={`slider slider-round ${isDisabledEdit ? "block-action" : ""}`}></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {
                  switchState.override_sor_brand && switchState.override_sor_brand != null && switchState.override_sor_brand != "0" ? (

                    <div className="col-md-4 col-lg-2">
                      <div
                        className="form-icon-group mb-4 d-block"
                        title="Brand Override"
                      >
                        <label>
                          Brand Override{" "}
                          <i className="fal fa-info-circle grade-icon"></i>
                        </label>
                        <Select
                          className={
                            "form-control custom-select-box" +
                            (errorMessage?.brandOverride ? " is-invalid" : "")
                          }
                          name="brand_override"
                          value={brandList.filter(function (option) {
                            return option.value == brandOverride;
                          })}
                          onChange={(value) => {
                            if (value) {
                              setBrandOverride(value.value);
                            } else {
                              setBrandOverride();
                            }
                          }}
                          isClearable
                          options={brandList}
                          maxMenuHeight={175}
                          placeholder={"Brand Override"}
                          isDisabled={isDisabledEdit || isGradeLocked}
                        />
                      </div>
                    </div>
                  ) : null
                }
                <div className="col-md-4 col-lg-2">
                  <div
                    className="form-icon-group mb-4 d-block"
                    title="Template"
                  >
                    <label>
                      Template <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <Select
                      className={`
                        form-control custom-select-box
                        ${errorMessage?.sorTemplate ? "is-invalid" : ""}
                        ${(isDisabledEdit || isGradeLocked) ? "block-action" : ""}
                      `}
                      name="sor_template"
                      value={sorTemplateList.filter(function (option) {
                        return option.value == sorTemplatevalue;
                      })}
                      onChange={(value) => setsorTemplatevalue(value ? value.value : "")}
                      isClearable
                      options={sorTemplateList}
                      maxMenuHeight={175}
                      placeholder={"Template"}
                      isDisabled={isDisabledEdit || isGradeLocked}
                    />
                  </div>
                </div>
              </div>
              <div className="edit-icon new-card-header">
                <div className="card-header">
                <i className="fas fa-cog heading-theme-color mr-2" ></i> 
                  Grading{" "}
                  {loading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
              </div>
              <div className="row grade-store-box ">
                <div className="col-md-4 col-lg-2">
                  <div
                    className="form-icon-group mb-4 d-block"
                    title="Grade Type"
                  >
                    <label>Grade Type </label>
                    <Select
                      className={`
                        form-control custom-select-box
                        ${errorMessage?.gradeType ? "is-invalid" : ""}
                        ${(isDisabledEdit || isGradeLocked) ? "block-action" : ""}
                      `}
                      name="grade_type"
                      value={gradeTypeArr.filter(function (option) {
                        return option.value === gradeTypeValue;
                      })}
                      onChange={(value) => {
                        if (value) {
                          setGradeTypeValue(value.value);
                          setAggregationMethodValue();
                          setDropoutValue("");
                          setPassMarkValue(null);
                          setPassMark("");
                          setSelectedTemplate({});
                          setErrorMessage((prevState) => ({
                            ...prevState,
                            gradeType: "",
                          }));
                        } else {
                          setGradeTypeValue();
                          setPassMarkValue(null);
                          setPassMark("");
                          setAggregationMethodValue();
                          setDropoutValue("");
                          setSelectedTemplate({});
                          setErrorMessage((prevState) => ({
                            ...prevState,
                            gradeType: "Grade Type is Required",
                          }));
                        }
                      }}
                      isClearable
                      options={gradeTypeArr}
                      maxMenuHeight={175}
                      placeholder={"Grade Type"}
                      isDisabled={isDisabledEdit || isGradeLocked}
                    />
                  </div>
                </div>
                {gradeTypeValue || +gradeTypeValue === 0 ? (
                  <>
                    {gradeTypeValue != "3" && (
                      <div className="col-md-4 col-lg-2">
                        <div
                          className="form-icon-group mb-4 d-block"
                          title="Aggregation Method"
                        >
                          <label>
                            Aggregation Method{" "}
                            <i
                              className="fal fa-info-circle grade-icon"
                              title={tooltipObj.aggregationMethodTooltip}
                            ></i>
                          </label>
                          <Select
                            className={`
                              form-control custom-select-box
                              ${errorMessage?.aggregationMethod ? "is-invalid" : ""}
                              ${(isDisabledEdit || isGradeLocked) ? "block-action" : ""}
                            `}
                            name="aggregation_method"
                            value={aggregationTypeArr.filter(function (option) {
                              return option.value == aggregationMethodValue;
                            })}
                            onChange={(value) => {
                              if (value) {
                                setAggregationMethodValue(value.value);
                                setErrorMessage((prevState) => ({
                                  ...prevState,
                                  aggregationMethod: "",
                                }));
                              } else {
                                setAggregationMethodValue();
                                setErrorMessage((prevState) => ({
                                  ...prevState,
                                  aggregationMethod:
                                    "Aggregation Method is Required",
                                }));
                              }
                            }}
                            isClearable
                            options={aggregationTypeArr}
                            maxMenuHeight={175}
                            placeholder={"Aggregation Method"}
                            isDisabled={isDisabledEdit || isGradeLocked}
                          />
                        </div>
                      </div>
                    )}
                    {gradeTypeValue != "3" && (
                      <div className="col-md-4 col-lg-2" title="Dropout Value">
                        <label>
                          Dropout Value{" "}
                          <i
                            className="fal fa-info-circle grade-icon"
                            title={tooltipObj.dropoutTootltip}
                          ></i>
                        </label>
                        <div className="form-icon-group mb-4">
                          <input
                            className={
                              "form-control" +
                              (errorMessage.dropoutValue?.length
                                ? " is-invalid"
                                : "") + (isDisabledEdit ? " block-action" :  isGradeLocked ? " block-action" : "")
                            }
                            type="number"
                            onChange={(e) => {
                              setDropoutValue(e.target.value);
                            }}
                            value={dropoutValue}
                            placeholder="Dropout Value"
                            disabled={isDisabledEdit || isGradeLocked}
                          />
                        </div>
                      </div>
                    )}
                    {gradeTypeValue == "1" ? (
                      <div className="col-md-4 col-lg-2">
                        <div
                          className="form-icon-group mb-4 d-block"
                          title="Pass Mark"
                        >
                          <label>Pass Mark </label>
                          <Select
                            className={`
                              form-control custom-select-box
                              ${errorMessage?.passMark ? "is-invalid" : ""}
                              ${(isDisabledEdit || isGradeLocked) ? "block-action" : ""}
                            `}
                            name="pass_mark"
                            value={ options.find(option => String(option.value) === String(passMarkValue)) }
                            onChange={(value) => {
                              if (value) {
                                setPassMarkValue(value.value);
                              } else {
                                setPassMarkValue(null);
                              }
                            }}
                            isClearable
                            options={options.filter((_,index) => index != 0)}
                            maxMenuHeight={175}
                            placeholder={"Mark"}
                            isDisabled={isDisabledEdit || isGradeLocked}
                          />
                        </div>
                      </div>
                    ) : gradeTypeValue == "2" ? (
                      <div className="col-md-4 col-lg-2">
                        <div
                          className="form-icon-group mb-4 d-block"
                          title="Pass Mark"
                        >
                          <label>Pass Mark </label>
                          <Select
                            className={`
                              form-control custom-select-box
                              ${errorMessage?.passMark ? "is-invalid" : ""}
                              ${(isDisabledEdit || isGradeLocked) ? "block-action" : ""}
                            `}
                            name="pass_mark"
                            value={templatePassMarkArr.filter(function (
                              option
                            ) {
                              return option.value == passMarkValue;
                            })}
                            onChange={(value) => {
                              if (value) {
                                setPassMarkValue(value.value);
                                setErrorMessage((prevState) => ({
                                  ...prevState,
                                  passMark: "",
                                }));
                              } else {
                                setPassMarkValue(null);
                                setErrorMessage((prevState) => ({
                                  ...prevState,
                                  passMark: "Pass Mark is Required",
                                }));
                              }
                            }}
                            isClearable
                            options={templatePassMarkArr}
                            maxMenuHeight={175}
                            placeholder={"Mark"}
                            isDisabled={isDisabledEdit || isGradeLocked}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-4 col-lg-2" title="Pass Mark">
                        <label>Pass Mark </label>
                        <div className="form-icon-group mb-4">
                          <input
                            className={
                              "form-control" +
                              (errorMessage?.passMark ? " is-invalid" : "")+(isDisabledEdit ? " block-action" :  isGradeLocked ? " block-action" : "")
                            }
                            type="number"
                            onChange={(e) => {
                              if (e.target.value) {
                                setPassMark(e.target.value);
                              } else {
                                setPassMark("");
                              }
                            }}
                            value={passMark}
                            placeholder="Pass Mark"
                            disabled={isDisabledEdit || isGradeLocked}
                          />
                        </div>
                      </div>
                    )}
                    {gradeTypeValue == "2" && (
                      <div className="search-filter-div-right mb-4">
                        <label>&nbsp;</label>
                        <div className="filter-search-bar-blk">
                          <div className="add-ticket-blk dropdown-comman">
                            <button
                              data-toggle="modal"
                              data-target="#letterTemplatemodal"
                              className="btn btn-save btn-success"
                              type="button"
                              title="Select Template"
                              disabled={isDisabledEdit || isGradeLocked}
                            >
                              <i className="fal fa-file-alt"></i>Select Template
                            </button>
                            {selectedTemplate && (
                              <>
                                {selectedTemplate && selectedTemplate?.name && (
                                  <div className="d-flex select-delete">
                                    <Link
                                      className="as-text-blue curser"
                                      title="Open"
                                      to={`/courseAdministration/gradingTemplate/edit/${selectedTemplate?.id}`}
                                    >
                                      <span className="textLimit100">
                                        {selectedTemplate?.name}
                                      </span>
                                    </Link>
                                    <button
                                      className="btn btn-danger rounded-circle btn-dropdown-item"
                                      title="Delete"
                                      onClick={() => setSelectedTemplate({})}
                                      disabled={isDisabledEdit || isGradeLocked}
                                    >
                                      <i className="fal fa-trash-alt"></i>
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              <hr />
            </div>
          </div>
        </div>
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      <input
                        type="search"
                        className=""
                        placeholder="Search"
                        aria-controls="assessment-table-main"
                        onChange={handleSearchFilter}
                        value={search}
                      />
                    </label>
                    <div className="filter-eff filter-data-btn">
                      <button className="filter-buttons">
                        <i className="fal fa-filter"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div
                  className="custom-check custom-control custom-checkbox mt-2 mx-4"
                  title="Exclude empty grades"
                >
                  <input
                    type="checkbox"
                    className={`custom-control-input ${((isDisabledEdit || isGradeLocked) ? " block-action" : "")}`}
                    id="empty_grade"
                    name="select"
                    checked={excludeEmptyGrade}
                    onChange={(e) =>
                      setExcludeEmptyGrade(e.target.checked ? 1 : 0)
                    }
                    disabled={isDisabledEdit || isGradeLocked}
                  />
                  <label className="custom-control-label" htmlFor="empty_grade">
                    Exclude empty grades
                  </label>
                </div>
                {gradingStandard == 2 && (
                  <div className="filter-scroll">
                    <div className={`filter-scroll-inner  filter-custom-new`}>
                      <Tablefilter
                        filterName="Linked Assessment"
                        optionArr={linkedAssessmentDropdown.linkedAssessment}
                        state={assessmentIds}
                        setState={setAssessmentIds}
                        isSearchFilter={true}
                      />
                    </div>
                  </div>
                )}
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={resetFilter}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      title="Export spreadsheet"
                      onClick={() => {
                        gradingStandard == 2
                          ? exportGradeMixData(
                              "xlsx",
                              "Grade-settings-lists"
                            )
                          : exportData("xlsx", "Grade-settings-lists");
                      }}
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      title="Export CSV"
                      onClick={() => {
                        gradingStandard == 2
                          ? exportGradeMixData(
                              "csv",
                              "Grade-settings-lists"
                            )
                          : exportData("csv", "Grade-settings-lists");
                      }}
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      title="Export PDF"
                      onClick={() => {
                        gradingStandard == 2
                          ? exportGradeMixData(
                              "pdf",
                              "Grade-settings-lists"
                            )
                          : exportData("pdf", "Grade-settings-lists");
                      }}
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {tab != "versions" && <div className="search-filter-div-right">
            <div className="filter-search-bar-blk">
              <div className="add-ticket-blk button-reset dropdown-comman">
                <PermissionsGate
                  scopes={["capgsedit"]}
                  errorProps={{ disabled: true }}
                >
                  <button
                    className="btn btn-primary"
                    onClick={() => handleLockGrades()}
                    title={isGradeLocked ? "Unlock Grades" : "Lock Grades"}
                    disabled={isDisabledEdit ? true : gradeLockLoading}
                  >
                    {isGradeLocked ? (
                      <>
                        {gradeLockLoading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-unlock"></i>} Unlock Grades
                      </>
                    ) : (
                      <>
                        {gradeLockLoading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-lock"></i>} Lock Grades
                      </>
                    )}
                  </button>
                </PermissionsGate>
              </div>
            </div>
          </div>}
        </div>
        <DataTable
          columns={
            gradingStandard == 2
              ? gradeMixColumns.map((item) => item)
              : queryVersionId ? moduleColumns : [...columns]
          }
          pagination={false}
          defaultSortField={sortKey}
          defaultSortAsc={true}
          data={dataToRender()}
          noDataComponent={Str.noRecord}
          onSort={handleSort}
          sortServer
          paginationTotalRows={totalRows}
          highlightOnHover={false}
          progressComponent={<SkeletonTicketList />}
          progressPending={loading}
        />
        <div className="form-group form-group-save-cancel without-pagination-btns">
          <PermissionsGate
            scopes={["capgseedit"]}
            errorProps={{ disabled: true }}
          >
            <button
              className="btn btn-save btn-success"
              type="submit"
              title="Save"
              onClick={handleUpdateData}
              disabled={isDisabledEdit ? true : isDisabled}
            >
              {isDisabled ? (
                <i className="fas fa-cog fa-spin"></i>
              ) : (
                <i className="fal fa-save"></i>
              )}
              Save
            </button>
          </PermissionsGate>
          <button
            className={`btn btn-close btn-danger ${isDisabledEdit ? "block-action" : ""}`}
            type="button"
            title="Cancel"
            onClick={() => {
              setUpdateData(!updateData);
            }}
            disabled={isDisabledEdit}
          >
            <i className="fal fa-times"></i>Cancel
          </button>
          {errorMessage
            ? Object.keys(errorMessage).map((key) => {
                return errorMessage[key] ? (
                  <div className="invalid-feedback d-block" key={key}>
                    {errorMessage[key]}
                  </div>
                ) : (
                  <React.Fragment key={key}></React.Fragment>
                );
              })
            : ""}
        </div>
      </div>
      <ListOfTemplateModal
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}
      />
    </div>
  );
};

export default ProgrameGradeSetting;
